import { defineComponent as _defineComponent } from 'vue'
import { useTemplateApp } from '@/composables/useTemplateApp'
import { usePrimeCompletePopupStore } from '@/stores/primeCompletePopup'


export default /*#__PURE__*/_defineComponent({
  __name: 'PrimeCompletePopup',
  setup(__props) {

/**
 * ヤギプライム決済完了 UI。開閉は Pinia `usePrimeCompletePopupStore`。
 */
const store = usePrimeCompletePopupStore()
const { open: openTemplateApp } = useTemplateApp()

return { __sfc: true,store, openTemplateApp }
}

})